export enum StaffStatuses {
  General = 'With staff',
  Registrar = 'Registering',
  Provider = 'With provider',
  Nurse = 'With nurse',
  Ancillary = 'With ancillary',
  EVS = 'EVS in the room',
  Technician = 'With technician',
  'Medical Assistant' = 'With medical assistant',
  CNA = 'With CNA',
  Technologist = 'With technologist',
}
